import { MapCultureTo, MapStringTo, Nullable } from "../../base-types";

export interface IRelatedPath {
    readonly name: string;
    readonly items: ReadonlyArray<ReadonlyArray<IRelatedPathItem>>;
}

export interface IRelatedPathItem {
    readonly values: MapCultureTo<string>;
    readonly entity: URI | string;
    readonly definition: URI | string;
    readonly properties: Nullable<MapStringTo<unknown>>;
}
